import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/storybook-components';

export function Submit(props) {
  const onClick = (event) => props.onSubmit(event);

  return (
    <Button
      type='primary'
      className={props.className}
      onClick={onClick}
      disabled={props.disabled}>
      {props.children}
    </Button>
  );
}

export function Reset(props) {
  const onClick = (event) => props.onReset(event);

  return (
    <Button
      type='secondary'
      className={props.className}
      onClick={onClick}
      disabled={props.disabled}>
      {props.children}
    </Button>
  );
}

const commonProps = {
  /**
   * className to set on button
   */
  className: PropTypes.string,

  /**
   * Boolean to set button disabled
   */
  disabled: PropTypes.bool,
  /**
   * Text to display on button
   */
  children: PropTypes.string,
};

Submit.propTypes = {
  ...commonProps,
  /**
   * Fuction to invoke on click
   */
  onSubmit: PropTypes.func,
};

Reset.propTypes = {
  ...commonProps,
  /**
   * Function to invoke on click
   */
  onReset: PropTypes.func,
};
